<template>
  <div class='quill-editor-container'>
    <!--定制toolbar-->
    <!--<div :class="toolbarClass">-->
      <!--<Toolbar :mixStr="mixStr" :quill="quill"/>-->
    <!--</div>-->

    <div ref="quillRoot"></div>
  </div>
</template>

<script>
import _Quill from 'quill'
import 'quill/dist/quill.snow.css' // 这里目前只引用了snow主题的样式
// import { options } from '../../../const/eidtor'
import Toolbar from '../toolbar/toolbar'
import _ from 'lodash'
import {
  handleMarkdown
  // handleEditorMarkdown
} from '../core/markdown'
import { transform } from '../../../../lib'
import {
  isSyncing,
  isSelectAll,
  deleteLock,
  handleWrapType,
  handleWrap,
  getChineseDelta,
  handleSelectStyle,
  chineseLock,
  markdownLock,
  wrapType,
  getCurLength,
  selectLength,
  getStyle,
  historyContentCopy,
  cacheLock,
  curCacheOps,
  curOpsDelta,
  getEditorText,
  receiveOperationQueue
} from '../../../mixin/docs'
import hljs from 'highlight.js'
import 'highlight.js/styles/androidstudio.css' // 可以在这里更换喜欢的，后面可以参考mavon-editor封装成一个参数

const Quill = window.Quill || _Quill

export default {
  name: 'QuillEditor',

  data () {
    return {
      specialDelta: [],
      localOptions: {
        theme: 'snow',
        boundary: document.body,
        modules: {
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          },
          // toolbar: `#quill-toolbar-${this.mixStr}`
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],

            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],

            ['clean']
          ]
        },
        placeholder: '',
        readOnly: false
      },
      localContent: '',
      curIndex: 0,
      idDeleteAll: false,
      quill: {}
    }
  },

  components: {
    Toolbar
  },

  props: {
    content: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    mixStr: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      required: false,
      default: () => {}
    },
    globalOptions: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  created () {
    // console.log('mixStr', this.mixStr)
  },

  watch: {
    content (newVal, oldVal) {
      if (this.quill) {
        if (newVal && newVal !== this.localContent) {
          this.localContent = newVal
          this.quill.pasteHTML(newVal)
        } else if (!newVal) {
          this.quill.setText('')
        }
      }
    },
    value (newVal, oldVal) {
      if (this.quill) {
        if (newVal && newVal !== this.localContent) {
          this.localContent = newVal
          this.quill.pasteHTML(newVal)
        } else if (!newVal) {
          this.quill.setText('')
        }
      }
    },
    disabled (newVal, oldVal) {
      if (this.quill) {
        this.quill.enable(!newVal)
      }
    }
  },
  computed: {},
  methods: {
    initQuill () {
      if (this.$el) {
        this.localOptions = Object.assign({}, this.localOptions, this.globalOptions, this.options)

        // 重写quill的size
        let Size = Quill.import('attributors/style/size')
        Size.whitelist = ['9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '30px']
        Quill.register(Size, true)

        // 添加宋体、楷体、微软雅黑、黑体
        let Font = Quill.import('attributors/style/font')
        Font.whitelist = ['SimSun', 'KaiTi', 'Microsoft-YaHei', 'SimHei']
        Quill.register(Font, true)

        this.quill = new Quill(this.$refs.quillRoot, this.localOptions)

        // 监听编辑器内容是否被删除完了
        this.quill.container.firstChild.addEventListener('keydown', (event) => {
          let curStyle = getStyle(this.quill)
          if (this.idDeleteAll) {
            this.quill.format('code-block', null) // 将本地的代码块去掉
            let deltaData = []
            deltaData.push({
              retain: 1,
              attributes: {'code-block': null}
            })
            this.$emit('send-message', [deltaData]) // 发送给协同者这个消息
            this.idDeleteAll = false
            return
          }
          if (event.keyCode === 8 && getCurLength(this.quill) === 1 && curStyle['code-block']) {
            console.log('编辑器内容删除完了', getStyle(this.quill))
            this.idDeleteAll = true
          }
        })

        // 监听非直接输入开始（主要指中文）
        this.quill.container.firstChild.addEventListener('compositionstart', (event) => {
          // console.log('你开始输入中文了', event)
          chineseLock(true)
        })

        // 监听非直接输入结束（主要是单独处理中文）
        this.quill.container.firstChild.addEventListener('compositionend', (event) => {
          console.log('你结束输入中文了', this.specialDelta)
          let deltaData = getChineseDelta(this.specialDelta)
          let deltaDataChanged = [_.cloneDeep(deltaData)]
          console.log('产出的deltaDataChanged', _.cloneDeep(deltaDataChanged))

          // 如果再输入中文的过程中收到了别人的消息的话此时发出的中文位置应该相应的更改
          if (receiveOperationQueue().length > 0 && deltaDataChanged.length > 0) {
            console.log('receiveOperationQueue', receiveOperationQueue())
            receiveOperationQueue().map(item => {
              transform(deltaDataChanged, ...item)
            })
          }
          console.log('被同步消息影响过的deltaDataChanged', deltaDataChanged)

          // 将接下来的操作缓存
          if (cacheLock()) curCacheOps().push(...deltaDataChanged)

          if (!cacheLock()) {
            curOpsDelta(...deltaDataChanged) // 如果没有缓存锁保存当前操作
            this.$emit('send-message', deltaDataChanged) // 发出消息
          }

          this.specialDelta = []
          chineseLock(false)
          receiveOperationQueue([]) // 清除收到的同步消息队列
          this.$emit('execute-sync', _.cloneDeep(...deltaDataChanged)) // 中文锁解除，立刻执行缓存的同步消息
          selectLength(0)
        })

        // 监听编辑器内容变化
        this.quill.on('text-change', (delta, oldDelta, source) => {
          this.$emit('text-change', {delta, oldDelta, source})
          // console.log('编辑器内发生了改变', _.cloneDeep(delta))
          if (isSyncing()) return // 同步锁
          this.handleInit(delta, oldDelta) // 初始化一些数据
          let specialDelta = _.cloneDeep(delta.ops)

          if (chineseLock()) this.specialDelta.push(delta.ops) // 为了中文输入而保存的数据
          if (!cacheLock()) curOpsDelta(specialDelta)
          if (cacheLock() && !markdownLock() && !chineseLock()) curCacheOps().push(specialDelta) // 将接下来的操作缓存

          // handleEditorMarkdown(this, specialDelta) // 匹配quill自带的markdown语法
          handleMarkdown(this.quill, getEditorText(this.quill)) // 执行markdown语法转换
          handleWrapType(this, specialDelta) // 匹配两个换行在一起的情况
          handleSelectStyle(this.quill, specialDelta) // 处理选中文本有多种样式的情况

          if (deleteLock()) { // 代码块删除锁
            let isDeleteCode = specialDelta.some(item => item.delete)
            let isCode = specialDelta.some(item => item.attributes === null)
            if (!isDeleteCode || isCode) {
              deleteLock(false)
              wrapType('')
            } else {
              handleWrap(this)
              return
            }
          }

          if (!chineseLock() && !cacheLock() && !markdownLock()) {
            this.$emit('send-message', [specialDelta])
          }

          if (wrapType() === 'codeWrap') deleteLock(true)

          this.handleReset() // 重置一些数据
        })

        // 监听光标位置，以及当前选中的区域
        this.quill.on('selection-change', (range, oldRange, source) => {
          this.$emit('selection-change', {range, oldRange, source})
          if (!range) {
            this.$emit('blur', this.quill)
          } else {
            this.curIndex = range.index
            if (range.length === 0 || range.length > getCurLength(this.quill)) {
              selectLength(0)
            } else {
              selectLength(range.length)
            }
            this.$emit('focus', this.quill)
          }
        })
        this.$emit('editor-ready', this.quill)
      }
    },

    handleInit (delta, oldDelta) {
      let curSelectLength = selectLength()
      let curTextLength = getCurLength(this.quill)
      if (curTextLength !== 2 && curTextLength - curSelectLength === 1) isSelectAll(true)
      historyContentCopy(oldDelta.ops)
    },

    toolbarClass () {
      return {
        'docs-toolbar': !this.isTop
      }
    },

    handleReset () {
      selectLength(0)
      isSelectAll(false)
    }
  },

  mounted () {
    setTimeout(() => {
      this.initQuill()
    }, 0)
  },

  beforeDestroy () {
    this.quill = null
    delete this.quill
  }
}
</script>

<style scoped lang='scss'>
  .quill-editor-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/quill/components/QuillEditor.vue